<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
// import OrcamentosTable from './orcamentos-table'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/orcamentos_anim.json'
import exportFromJSON from "export-from-json"
import DropZone from "@/components/widgets/dropZone.vue";
import { ref } from "vue";
import useVuelidate from "@vuelidate/core";
import moment from "moment/moment";
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from "file-saver-es";
import DxButton from 'devextreme-vue/button';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import Multiselect from "@vueform/multiselect";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "Orçamentos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    DropZone, Layout, PageHeader, Loader,
    DxButton, DxDropDownButton,DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations, Multiselect
    // OrcamentosTable,
  },

  mounted() {
    console.log('mounted orcamentos-list_0')

    this.atualizaDataList()
  },

  data() {
    return {

      animationJson,
      title: 'Orçamentos',
      items: [
        {
          text: 'Comercial',
          href: '/',
        },
        {
          text: 'Orçamentos',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      orctoList: null,
      orctoChart1: null,
      orctoChart2: null,
      pesqTextFilter: '',
      // statusFilter: 'DF',
      valorTotal: 0,
      valorTotalConf: 0,
      valorTotalConfParc: 0,
      valorTotalElab: 0,
      valorTotalFat: 0,
      showModalImport: false,
      submittedAnexo: false,
      descranexo: '',

      currentPage: 1,
      totalPages: 0,
      submittedPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,

      paramExibCarga: false,
      cargasList: null,

      statusFilterValue: 'T',
      statusFilter: [
        {value: 'T', text: 'Todos os Status'},
        {value: 'CA', text: 'Cancelados'},
        {value: 'CP', text: 'Conf. Parcial'},
        {value: 'CO', text: 'Conferidos'},
        {value: 'FA', text: 'Faturados'},
        {value: 'EL', text: 'Em Elaboração'},
        {value: 'SC', text: 'Solicitação de cancelamento'},
      ],

      dropdownOptions:[
        {value: 'imp', text: 'Importar Excel'},
        {value: 'exp', text: 'Exportar Excel'},
        {value: 'relPer', text: 'Relatório Orçamento no Período'},
        {value: 'relRep', text: 'Relatório Orçamento por Representante'},
      ],

      empresaRemet: [],
      listaIds: [],
      dtListErrorsProdutos: [],
      showModalErrosProdutos: false,

      showModalAssociaLotes: false,
      dtListAssociaLote: [],
      dtListLotes: [],
      loteSelected: [],
      lotesCache: {},

      showModalWait: false,
      updatingReserva: false
    }
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };

    // return { dropzoneFile, drop};
    return { v$: useVuelidate(), dropzoneFile, drop };
  },


  methods: {
    gerarRelatorioValidacaoSaldo(){
      console.log('gerarRelatorioValidacaoSaldo')

      api.post(`${getBaseUrl()}api/relatoriovalidacaosaldo`, {
        origem: "orcamento",
        listItens: this.dtListErrorsProdutos
      },
      {
       responseType: 'blob'
      }
      ).then((res) => {
        console.log('then axios relatoriovalidacaosaldo')

        const blob = new Blob([res.data], {type: 'application/pdf'})
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Relatorio_Validacao_Saldo_Itens_orcamento.pdf')
        document.body.appendChild(link)
        link.click()
        link.remove()
      }).catch((error) => {
        console.log('Erro ao gerar relatório: ', error)
      })
    },

    criaMovAjtFromOrcto() {
      console.log('criaMovAjtFromOrcto')

      api.post(`${getBaseUrl()}api/criamovajtmovs`, {
        produtosErros: this.dtListErrorsProdutos,
        remetcnpj: this.empresaRemet,
        tabela: 'orcamento',
        origens_id: this.listaIds
      }).then((res) => {
        console.log('then axios criamovajtmovs')
        console.log(res.data)
        // console.log(JSON.stringify(res.data))

        if (res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            text: res.data.message ?? "Ajuste criado com sucesso!",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            const movajt_id = res.data.movajt_id
            if(movajt_id > 0) {
              let route = this.$router.resolve(`/movajuste/editar/${movajt_id}`);
              window.open(route.href, '_blank');
              this.showModalErrosProdutos = false
            } else {
              let route = this.$router.resolve(`/movajustes/list`);
              window.open(route.href, '_blank');
            }

          });
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            text: res.data.error ?? "Criação de Ajuste Falhou!",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            this.atualizaDataList()
          });
        }
      })
    },

    gerarReservaSaldos() {
      console.log('gerarReservaSaldos')

      /*
      * Antes de realizar qualquer disparo, verificar se todos os lotes foram definidos
      */
      let validado = true
      this.dtListAssociaLote.forEach(item => {
        if(!item.lote || item.lote < 1) {
          validado = false
        }
      })

      if(!validado) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Todos os itens devem estar com lotes definidos!",
          showConfirmButton: false,
          timer: 3500,
        })
      } else {
        this.updatingReserva = true

        api.post(`${getBaseUrl()}api/reservasaldoloteswmsos`, {
          itens: this.dtListAssociaLote
        }).then((res) => {
          console.log("then axios reservasaldolotes");
          console.log(res.data)
          console.log(JSON.stringify(res.data))

          this.showModalAssociaLotes = false
          this.updatingReserva = false

          if(res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.$router.push('/wmsossaida/list')
            })
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: res.data.message,
              text: "Deseja visualizar erros com mais detalhes?",
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
            }).then((confirmed) => {
              if(confirmed.isConfirmed){

                //console.log(`Quantidade dtListErrorsProdutos: ${this.dtListErrorsProdutos.length}`)
                //console.log(JSON.stringify(this.dtListErrorsProdutos))

                if(this.dtListErrors.length > 0) {
                  this.showModalErros = true
                }

                if (this.dtListErrorsProdutos.length > 0) {
                  this.showModalErrosProdutos = true
                }
              } else {
                this.$router.push('/wmsossaida/list')
              }
            })
          }
        })
      }
    },

    validaSaldoProduto() {
      console.log('validaSaldoProduto')

      const linhas = this.dataGrid.getSelectedRowsData()
      // console.log('linhas selecionadas:')
      // console.log(JSON.stringify(this.dataGrid.getSelectedRowsData()))

      const validacaoEmpresas = this.validaEmpresasSelecionadas(linhas)
      if (!validacaoEmpresas) {
        return
      }

      this.listaIds = [...new Set(linhas.map(item => item.id))]

      api.post(`${getBaseUrl()}api/validasaldoprod`, {
        listaIds: this.listaIds,
        remetcnpj: this.empresaRemet,
        tabela: 'orcamento'
      }).then((res) => {
        console.log('then axios validasaldoprod')
        console.log(res.data)
        // console.log(JSON.stringify(res.data))

        if(res.data.success && res.data.validado) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            text: res.data.message,
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.listaIds = []
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            text: res.data.error,
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.dtListErrorsProdutos = res.data.listaProdutos ?? []

            if (this.dtListErrorsProdutos.length > 0) {
              this.showModalErrosProdutos = true
            }
          })
        }
      })
    },

    validaEmpresasSelecionadas(linhas) {
      console.log('validaEmpresasSelecionadas')

      const empresaRemet = [...new Set(linhas.map(item => item.empresa))]

      if(empresaRemet.length > 1) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Apenas uma empresa por validação!",
          showConfirmButton: false,
          timer: 3500,
        })

        return false
      }
      console.log(`empresaRemet: ${JSON.stringify(empresaRemet)}`)
      this.empresaRemet = empresaRemet[0] ?? null

      return true
    },

    gerarOs() {
      console.log('Orcamento - gerarOs')

      const linhas = this.dataGrid.getSelectedRowsData()
      // console.log(JSON.stringify(linhas))


      if(this.listaIds.length > 50) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Máximo de 50 notas por vez!",
          showConfirmButton: false,
          timer: 2500
        })
        return
      }

      const validacaoEmpresas = this.validaEmpresasSelecionadas(linhas)
      if (!validacaoEmpresas) {
        return
      }

      this.listaIds = [...new Set(linhas.map(item => item.id))]
      console.log(JSON.stringify(this.listaIds))

      if (this.listaIds.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum orçamento foi selecionado, favor selecionar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        Swal.fire({
          position: "center",
          icon: "question",
          input: 'select',
          inputValue: 't',
          inputOptions: {
            t: 'Todos os movimentos',
          },
          title: "Gerar Ordens de Serviço (Orçamentos " + this.listaIds + ")",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if(result.isConfirmed){
            this.updatingReserva = true
            this.showModalWait = true

            api.get(`${getBaseUrl()}api/geraosorctolote`,{
              params: {
                'listaIds': this.listaIds,
                'tipo': result.value,
                'remetcnpj': this.empresaRemet
              }
            }).then(res => {
              console.log("then geraosorctolote")
              console.log(JSON.stringify(res.data))

              this.updatingReserva = false
              this.showModalWait = false

              if(res.data.success && res.data.validado) {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 2500
                }).then(() => {
                  this.$router.push('/wmsossaida/list')
                })
              } else {
                /*
                * Verificando qual tipo de erro
                 */
                let icon = "warning"
                if(!res.data.success && !res.data.validado) {
                  icon = "error"
                }

                Swal.fire({
                  position: "center",
                  icon: icon,
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 2500
                }).then(() => {
                  this.dtListErrorsProdutos = res.data.itensSemSaldo ?? []
                  this.dtListAssociaLote = res.data.itensDefLote ?? []

                  if(this.dtListErrorsProdutos.length > 0) {
                    console.log('modal erro saldos')

                    this.showModalErrosProdutos = true
                  } else if(this.dtListAssociaLote.length > 0) {
                    console.log('modal erro lotes')

                    Swal.fire({
                      position: "center",
                      icon: "warning",
                      title: "Atente-se!",
                      text: "Ao selecionar uma quantidade equivocada, pode-se prejudicar a reserva de outro item!",
                      showConfirmButton: true,
                    })

                    this.showModalAssociaLotes = true
                  }
                })
              }
            })
          }
        })
      }
    },

    cancelarImportExcel() {
      this.descranexo = ''
      this.dropzoneFile = ''
      this.showModalImport = false
    },

    atualizaPagina() {
      window.location.reload();
    },

    confImportar() {
      console.log('confImportar')
      let arquivo = document.querySelector(".dropzoneFile").files[0]
      let formData = new FormData()
      formData.append("file", arquivo)
      this.showModalImport = false
      this.loadingList = true

      if (window.location.href.includes('localhost') || window.location.href.includes('salgadinhosclick')){
        console.log('importar novo orcamento')

        api.post(`${getBaseUrl()}api/orctoimpnovo`, formData, { // movfileanexo
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios confImportar')
          console.log(res.data)
          this.loadingList = false

          if (res.data.success === false) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: 'Erro de importação do excel',
              text: res.data.message,
              showConfirmButton: false,
              timer: 2500
            }).then(() => {
              this.descranexo = ''
              this.dropzoneFile = ''

              // this.atualizaPagina()
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações importadas com sucesso!",
              showConfirmButton: false,
              timer: 3000
            }).then(() => {
              this.atualizaPagina()
            })
          }


        }).catch((err) => {

          console.log('erro axios')
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingFiles = false
        }).then(() => {
          this.descranexo = ''
          this.dropzoneFile = ''

          // this.atualizaPagina()
        })


      } else {
        api.post(`${getBaseUrl()}api/orctoimpfile`, formData, { // movfileanexo
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios confImportar')
          console.log(res)
          this.loadingList = false


          //Tratando mensagem de retorno para o usuário
          if (res.data.success === false) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: 'Erro de importação do excel',
              text: res.data.message,
              showConfirmButton: false,
              timer: 2500
            }).then(() => {
              this.descranexo = ''
              this.dropzoneFile = ''

              // this.atualizaPagina()
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações importadas com sucesso!",
              showConfirmButton: false,
              timer: 3000
            }).then(() => {
              this.$router.push(`/orcamento/editar/${res.data.id}`)
            })
          }

          // this.mediasData = res.data[0]
          // this.loadingFiles = false
          //
          // this.showModaleditarPed = false
          //
          // Swal.fire({
          //   position: "top-end",
          //   icon: "success",
          //   title: "Informações salvas com sucesso!",
          //   showConfirmButton: false,
          //   timer: 1500
          // })

        }).catch((err) => {

          console.log('erro axios')
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingFiles = false
        }).then(() => {
          this.descranexo = ''
          this.dropzoneFile = ''

          // this.atualizaPagina()
        })
      }
    },

    selectedFile() {
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')
    },


    emitRelatPer() {
      console.log('emitRelatPer')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relorc01`, {
        params:{
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro
        },
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_orcamento_no_periodo.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelat002() {
      console.log('emitRelat002')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relorc02`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_orcamentos_002.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelatRep() {
      console.log('emitRelatRep')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relorc03`, {
        params:{
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro
        },
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_orcamento_por_representante.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },


    exportExcel() {
      console.log('exportExcel')
      const data = this.orctoList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },


    importExcel() {
      console.log('importExcel')
      this.showModalImport = true
      // const data = this.orctoList
      // const fileName = "exp_dados";
      // const exportType = exportFromJSON.types.xls;
      // if (data) exportFromJSON({ data, fileName, exportType });
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    atualizaDataList() {

      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      this.loadingList = true
      api.get(`${getBaseUrl()}api/orcamentos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilterValue,
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.orctoList = res.data[0]

        const dtIniFormated = moment(this.dtIniFiltro)
            .format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro)
            .format('DD/MM/YYYY')

        this.title = `(${this.orctoList.length}) Orçamentos: ${dtIniFormated} - ${dtFimFormated}`
        this.loadingList = false

        // console.log('orcamentosChart1')
        // console.log(orcamentosChart1)


        let valorTotalLoc = 0
        let valorTotalConf = 0
        let valorTotalConfParc = 0
        let valorTotalElab = 0
        let valorTotalFat = 0
        this.orctoList.forEach((value) => {

          valorTotalLoc += value.valorliq

          if (value.status === 'EL') {
            valorTotalElab += value.valorliq
          } else if (value.status === 'CP') {
            valorTotalConfParc += value.valorliq
          } else if (value.status === 'CO') {
          valorTotalConf += value.valorliq
          } else if (value.status === 'FA') {
            valorTotalFat += value.valorliq
          }

        })

        this.valorTotal = valorTotalLoc
        this.valorTotalElab = valorTotalElab
        this.valorTotalConfParc = valorTotalConfParc
        this.valorTotalConf = valorTotalConf
        this.valorTotalFat = valorTotalFat




        let labelsLocG1 = []
        let series01G1 = []
        let series02G1 = []
        res.data[1].forEach((value) => {
          // console.log(value)
          labelsLocG1.push(value.month)
          if (value.status === 'FA') {
            series01G1.push(value.valor)
          } else {
            series02G1.push(value.valor)
          }
        })
        const uniquelabelsLocG1 = [...new Set(labelsLocG1)]
        // console.log('series02G1')
        // console.log(series02G1)
        this.orctoChart1 = {
          series: [{
            name: 'Faturados',
            type: 'column',
            data: series01G1
          },
          {
            name: 'Outros',
            type: 'line',
            data: series02G1
          }],
          chartOptions: {
            chart: {
              stacked: false,
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              width: 2,
              curve: 'smooth'
            },
            plotOptions: {
              bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
              }
            },
            colors: ['#34c38f', '#556ee6'],
            fill: {
              gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                //stops: [0, 100, 100, 100]
              }
            },
            labels: uniquelabelsLocG1,
            markers: {
              size: 0
            },
            yaxis: {
              min: 0
            },
          }
        }

        let labelsLocG2 = []
        let series01G2 = []
        let valorTotal = 0.00
        res.data[2].forEach((value) => {
          valorTotal += parseInt(value.valor)
        })
        // console.log('valorTotal_G2')
        // console.log(valorTotal)
        res.data[2].forEach((value) => {
          // console.log(value)
          labelsLocG2.push(value.nome)

          const valorPerc = parseInt(value.valor / valorTotal * 100)
          // console.log(valorPerc)

          series01G2.push(valorPerc)
        })
        this.orctoChart2 = {
          series: series01G2,
          chartOptions: {
            plotOptions: {
              radialBar: {
                dataLabels: {
                  name: {
                    fontSize: '22px',
                  },
                  value: {
                    fontSize: '16px',
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    // eslint-disable-next-line no-unused-vars
                    formatter: function (w) {
                      // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                      return valorTotal
                    }
                  }
                }
              }
            },
            labels: labelsLocG2,
            colors: ['#ff5900', '#ff9c00', '#3ec334', '#4cf1b7', '#f46a6a'],
          }
        }

        res.data[3].forEach((valueParam) => {
          if (valueParam) {
            console.log('valueParam')
            console.log(valueParam)
            if (valueParam.valor === 'EXIB_CARGA_ORCTO'){
              this.paramExibCarga = true
              this.cargasList = res.data[4]
            }
          }
        })

        this.loadingGraph = false
      });
    },

    delOrctoEmLote() {
      console.log('delOrctoEmLote')
      console.log(this.dataGrid.getSelectedRowsData())

      const idsData = this.dataGrid.getSelectedRowKeys();
      // console.log('idsData: ', idsData)

      Swal.fire({
        position: "top",
        icon: "warning",
        title: "Exclusão de Orçamento em Lote",
        text: `Esta ação irá deletar todos os orçamentos selecionados. Deseja confirmar esta ação?`,
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // Confirmou
          console.log('Confirmou exclusão!')
          api.delete(`${getBaseUrl()}api/orcamento`, {
            params: {
              iddata: idsData
            }
          }).then((res)=>{
            console.log('then axios delete orçamento')
            console.log(res.data)

            if(res.data.success === true){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.data,
                showConfirmButton: false,
                timer: 2000
              })

              //this.atualizaDataList();
              window.location.reload();


            }

          })
        }
      })
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/orcamento`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)

        if(res.data.success === true){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.data,
            showConfirmButton: false,
            timer: 2000
          })

          this.atualizaDataList();

        }
      })
    },

    criarNovo() {
      console.log('criarNovo')
      this.$router.push({ path: '/orcamento/editar/0' })
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Orçamentos: ${dtIniFormated} - ${dtFimFormated}`
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')

      let idData = row.key
        console.log(idData)

      this.$router.push(`/orcamento/editar/${idData}`)

    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'CA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SC':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CO':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'FA':
              corStatus = 'rgb(253,179,52)'
              break
            case 'EL':
              corStatus = 'rgb(5,126,236)'
              break
            case 'CP':
              corStatus = 'rgb(51,122,183)'
              break

          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        }
      }
    },

    onDropClick(e){
      const clickedValue = e.itemData.value;

      switch (clickedValue) {
        case 'imp':
          this.importExcel();
          break;
        case 'exp':
          this.exportExcel();
          break;
        case 'relPer':
          this.emitRelatPer();
          break;
        case 'relRep':
          this.emitRelatRep();
          break;
        default:
          console.log('Ação não definida');
      }
    },

    onFilterClick(e){
      const filteredValue = e.itemData.value;
      this.statusFilterValue = filteredValue;

      this.atualizaDataList();
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    nomeStatus(e) {
      switch (e.value) {
        case 'FA':
          return 'Faturado (FA)'
        case 'EL':
          return 'Em Elaboração (EL)'
        case 'CP':
          return 'Conf. Parcial (CP)'
        case 'CO':
          return 'Confirmado (CO)'
        case 'CA':
          return 'Cancelado (CA)'
        case 'SC':
          return 'Solicitação cancelamento (SC)'
      }

      return 'Não Definido'
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 4 });
      }
      return "0,0000";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    }


  },
}

</script>

<template>
  <Layout>

    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>
      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxDropDownButton
              v-model="statusFilterValue"
              :items="statusFilter"
              :drop-down-options="{ width: 150 }"
              icon="filter"
              show-arrow="false"
              hint="Filtrar Status"
              display-expr="text"
              value-expr="value"
              @item-click="onFilterClick"
          />
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Cadastrar novo orçamento"
              text="Novo Orçamento"
              :on-click="criarNovo"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxDropDownButton
              :items="dropdownOptions"
              :drop-down-options="{ width: 270 }"
              text="Import/Export de Aquivo"
              display-expr="text"
              value-expr="value"
              icon="file"
              @item-click="onDropClick"
          />
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="trash"
              hint="Delete em Lote"
              text="Delete em Lote"
              :on-click="delOrctoEmLote"/>
              
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="search"
              hint="Verificar saldo produto"
              text="Validar saldo de produto"
              :on-click="validaSaldoProduto"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="toolbox"
              hint="Gerar Separação"
              text="Gerar Separação"
              :on-click="gerarOs"/>
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="loadingList" style="min-height: 300px;">
    </Loader>

    <div class="row mt-2" v-if="paramExibCarga">
      <span>Todas as Cargas</span>
      <div class="text-center text-muted">
        <div class="row">
          <div class="col-1" v-for="data in cargasList" :key="data.carga">
            <div class="mt-4">
              <p class="mb-2 text-truncate">
                <i class="mdi mdi-circle text-success me-1"></i>
                {{ data.carga }}
              </p>
              <h5> {{ formatDecimal(data.cubtot) }} m³</h5>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="mt-2" v-if="!loadingList">
      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="orctoList"
          :show-borders="true"
          :focused-row-enabled="true"
          :keyExpr="'id'"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true"/>


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>


        <DxGroupPanel :visible="true"/>
        <DxGrouping/>

        <DxColumn
            data-field="id"
            caption="ID"
            sort-order="desc"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn data-field="status" caption="Status" data-type="text" alignment="center" :customize-text="nomeStatus"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="true" />

        <DxColumn
            data-field="numped"
            caption="Núm. pedido"
            sort-order="desc"
            data-type="text"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cliente"
            caption="Cód. Cliente"
            data-type="text"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="nome"
            caption="Cliente"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>
        
        <DxColumn
            data-field="agregped_id"
            caption="Agrega Ped. ID"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allow-sorting="true"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="email"
            caption="Email"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tel1"
            caption="Telefone"
            data-type="text"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="listawmsos"
            caption="OS associadas"
            sort-order="desc"
            data-type="text"
            alignment="right"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="wmsroma_id"
            caption="ID Romaneio"
            sort-order="desc"
            data-type="text"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="condpgto"
            caption="Condição Pgto"
            data-type="text"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="formapgto"
            caption="forma Pgto"
            data-type="text"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cidade"
            caption="Cidade"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="created_at"
            caption="Dt. Criação"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="updated_at"
            caption="Dt. Atualizado"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="110"
            data-field="valorliq"
            caption="Valor"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            :width="110"
            data-field="peso"
            caption="Peso"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>

    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Criar Novo Anexo" v-model="showModalImport" centered hide-footer @hidden="cancelarImportExcel">
      <div>
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input id="descranexo" type="text" v-model="descranexo" class="form-control"
                  placeholder="Descrição do anexo" :class="{ 'is-invalid': submittedAnexo && !descranexo }" />
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="cancelarImportExcel">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImportar">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalAssociaLotes"
        id="showModalAssociaLotes"
        size="xl"
        title="Associação de lotes"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Orçamento</th>
                    <th>Produto</th>
                    <th>Código</th>
                    <th>ID</th>
                    <th>Qtd.</th>
                    <th>Lote</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListAssociaLote" :key="data.id">
                    <td class="text-start">{{data.codigo}}</td>
                    <td class="text-start">{{data.descprod}}</td>
                    <td class="text-start">{{data.produto}}</td>
                    <td class="text-center">{{data.produto_id}}</td>
                    <td class="text-center">{{formatDecimal(data.qtd)}}</td>
                    <td class="text-center" style="width: 200px">
                      <multiselect
                          id="lotes"
                          v-model="data.lote"
                          :options="data.optionsLotes"
                          placeholder="Selecionar lotes"
                          label="cod"
                          track-by="cod"
                          value-prop="cod"
                      >
                        <template #option="slotProps">
                          <div class="row">
                            <div class="mt-2 font-size-16">
                              <span class="text-info">
                                {{ slotProps.option.cod }}
                              </span>
                              <span class="ms-2">
                                {{ `(Qtd: ${slotProps.option.saldo})` }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </multiselect>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="updatingReserva">
            <h3 class="text-info text-center">Aguarde um momento, estamos reservando os saldos dos produtos...</h3>
          </div>

          <div class="row" v-if="updatingReserva">
            <div class="col-12 text-center">
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
            </div>
          </div>

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAssociaLotes = false" :disabled="updatingReserva">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                @click="gerarReservaSaldos"
                :disabled="updatingReserva"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalErrosProdutos"
        id="showModalErrosProdutos"
        size="xl"
        title="Validação de saldo de produtos"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="mb-2 d-flex justify-content-end">
          <b-button
              type="submit"
              variant="danger"
              @click="gerarRelatorioValidacaoSaldo"
          >
            <i class="bx bxs-file-pdf font-size-16 align-middle"></i>
            Exportar
          </b-button>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Origem</th>
                    <th>Nota|Pedido</th>
                    <th>Produto</th>
                    <th>Código</th>
                    <th>ID</th>
                    <th>Lote</th>
                    <th>Qtd. Disponível</th>
                    <th>Qtd. Necessária</th>
                    <!--<th>Obs</th>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListErrorsProdutos" :key="data.id">
                    <td class="text-start">{{data.origem}}</td>
                    <td class="text-start">{{data.codigo}}</td>
                    <td class="text-start">{{data.produto_desc}}</td>
                    <td class="text-start">{{data.produto_cod}}</td>
                    <td class="text-center">{{data.produto_id}}</td>
                    <td class="text-start">{{data.lote ?? "-"}}</td>
                    <td class="text-center">{{formatDecimal(data.qtddisp)}}</td>
                    <td class="text-center">{{formatDecimal(data.qtdnecessaria)}}</td>
                    <!--<td class="text-start">{{data.message ?? "-"}}</td>-->
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div>
            <h6 class="text-danger text-end">Deseja gerar um ajuste de entrada?</h6>
          </div>

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalErrosProdutos = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                @click="criaMovAjtFromOrcto"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
             size="lg"
             v-model="showModalWait"
             centered hide-footer
    >
      <div v-if="updatingReserva">
        <h3 class="text-info text-center">Aguarde um momento...</h3>
      </div>

      <div class="row" v-if="updatingReserva">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>
    </b-modal>


  </Layout>
</template>
